// The live Promotions, read from the one doc Cloud Functions publish them to.
//
// They live in stats/promotions rather than on the sponsors' own user docs
// because firestore.rules only lets someone read their OWN users/{uid} — a
// rail that rendered other people's promos off user docs would be empty for
// everyone. stats/{id} is already readable by any signed-in user and writable
// only by functions, so this needs no rules change.
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useGuest, useGuestStat } from '../guestMode';
import { isTestMode } from '../testMode';
import type { LivePromotion } from '../api/promotions';

/** Already ordered by the function that writes it: lifetime value descending,
 *  which with one price is really longest-standing supporter first. */
export function usePromotions(): LivePromotion[] {
  const [live, setLive] = useState<LivePromotion[]>([]);
  // Signed-out preview: stats/promotions is closed to guests, so the same rail
  // comes from the public copy. The people on it pay for the exposure.
  const guestPromos = useGuestStat<{ live?: LivePromotion[] }>('promotions');
  const { guest } = useGuest();

  useEffect(() => {
    if (isTestMode || guest) return;
    return onSnapshot(
      doc(db, 'stats', 'promotions'),
      (snap) => setLive((snap.data()?.live as LivePromotion[]) ?? []),
      // A rail with no promos is the normal state, so a read failure just
      // renders the creators rather than an error.
      () => setLive([]),
    );
  }, [guest]);

  if (guest) return guestPromos?.live ?? [];
  return live;
}
